/** User delegation target type */
export enum UserDelegationTargetTypeEnum {
  /** Delegate active BRS tasks approvements */
  ACTIVE_BRS_TASKS_APPROVER = 'ACTIVE_BRS_TASKS_APPROVER',
  /** Delegate active BRS tasks auditions */
  ACTIVE_BRS_TASKS_AUDITOR = 'ACTIVE_BRS_TASKS_AUDITOR',
}
